import { render } from "./ThermIcon.vue?vue&type=template&id=27d0694a"
import script from "./ThermIcon.vue?vue&type=script&lang=ts"
export * from "./ThermIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script